import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './CheckoutIdentificationPage';

const CheckoutIdentificationPageSuspense = dynamic(
	() => import('./CheckoutIdentificationPage'),
	{ loading: () => <BlockLoadingSpinner /> },
);

export default function DynamicCheckoutIdentificationPage(props: Props) {
	return <CheckoutIdentificationPageSuspense {...props} />;
}
DynamicCheckoutIdentificationPage.displayName =
	'DynamicCheckoutIdentificationPage';
